
import React from 'react'
import GoogleMapSearch from '../../../../../../common/components/google-map-search';

export default function ParcelLocationComponent({ handleChange, quoteData, libraryData, setPickupLocation, pickupLocations, setDropLocation, dropLocations }: any) {

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">
            {/* Shipping Option */}
            <div>
                <label className="block text-xs font-semibold text-gray-700  mb-1">Shipping Option</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <select
                        className="w-full rounded-lg bg-transparent text-xs py-2 px-3"
                        id="default"
                        onChange={(event: any) => handleChange(event.target.value, 'type')}
                        value={quoteData?.type}
                    >
                        <option>--Select--</option>
                        {libraryData?.result?.ShippingOption?.map((item: any, index: any) => (
                            <option value={item.Text} key={index}>{item.Text}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Pickup Details */}
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">PickUp Details</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <GoogleMapSearch
                        setLocation={setPickupLocation}
                        location={pickupLocations}
                        placeholder="Pickup Details"
                    />
                </div>
            </div>

            <div>
                <label className="block text-xs font-semibold text-gray-700  mb-1">Name</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        name="pickupName"
                        placeholder=""
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value, 'pickupName')}
                        value={quoteData?.pickupName}
                    />
                </div>
            </div>
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Phone Number</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        name="pickupPhoneNumber"
                        maxLength={10}
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'pickupPhoneNumber')}
                        value={quoteData?.pickupPhoneNumber}
                    />
                </div>
            </div>
            {/* Pickup Address Additional Info */}
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Pickup Details Address Additional Info</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        name="from"
                        placeholder=""
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value, 'startBuilding')}
                        value={quoteData?.startBuilding}
                    />
                </div>
            </div>

            {/* Drop Details */}
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Drop Details</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <GoogleMapSearch
                        setLocation={setDropLocation}
                        location={dropLocations}
                        placeholder="Drop Details"
                    />
                </div>
            </div>
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Name</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        name="dropName"
                        placeholder=""
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value, 'dropName')}
                        value={quoteData?.dropName}
                    />
                </div>
            </div>
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Phone Number</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        maxLength={10}
                        name="dropPhoneNumber"
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value.replace(/\D/g, ''), 'dropPhoneNumber')}
                        value={quoteData?.dropPhoneNumber}
                    />
                </div>
            </div>
            {/* Drop Address Additional Info */}
            <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1">Drop Details Address Additional Info</label>
                <div className="w-full border border-gray-300 rounded-lg bg-gray-50">
                    <input
                        type="text"
                        name="from"
                        placeholder=""
                        className="w-full py-2 px-3 text-xs bg-transparent border-none"
                        onChange={(event: any) => handleChange(event.target.value, 'endBuilding')}
                        value={quoteData?.endBuilding}
                    />
                </div>
            </div>
        </div>



    )
}